import styled, { css } from 'styled-components';

interface CardProps {
  readonly width?: string;
  readonly maxWidth?: string;
  readonly justifyContent?: string;
  readonly marginLeft?: string;
  readonly padding?: string;
}

export const ActionItemCard = styled.div`
  min-width:654px;
  max-width:654px;
  border: 1px solid #E5E8ED;
  border-radius: 8px 8px 8px 8px;
  background-color: #FEFEFE;
  margin-bottom: 16px;
`

export const ActionItemCardTop = styled.div`
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
`

export const ActionItemCardTopTitle = styled.span`
  color: #424854;
  font-size: 16px;
  font-weight: bold;
  margin-right: 8px;
`

export const ActionItemCardTopNumber = styled.span`
  color: #5D6E81;
  font-size: 12px;
  font-weight: normal;
  margin-left: 2px;
`

export const ActionItemCardTopSubtitle = styled.h2`
  text-align: center;
  color: #5D6E81;
  font-size: 12px;
  font-weight: normal;
  margin-top: 0px;
`

export const Table = styled.table`
  width:100%;
  background-color: #FEFEFE;
  border-collapse:collapse;
  max-height: 310px;
  border-radius: 0px 0px 8px 8px;
`

export const TableHead = styled.thead`
  width: 100%;
  background-color: rgb(229,231,237,0.49) ;
  color: #424854;
  height:40px;
  display:block;
`

export const TableRow = styled.tr<CardProps>`
width:${props => props.width ? props.width : '100%'};
`

export const TableHeader = styled.th`
  color: #424854;
  font-size: 12px;
  font-weight: 500;
  height:40px;
  border: none;
  padding: 0;
  overflow-x: hidden;
  `

export const TableBody = styled.tbody`
  display: block;
  max-height: 200px;
  overflow-y: auto;   
  overflow-x: hidden; 

  tr{
    width:calc(100% - 1px);

    td{
      &:last-child{
        border-right: none;
      }
    }
  }
`

export const TableColumn = styled.td`
  max-height:30px;
  min-height:30px;
  overflow-x:hidden;
  height:30px;
  border: 1px solid rgb(229,231,237,0.49);
  text-align:center;
  font-size: 12px;
  color: #424854;
  width: calc(100% / 8);
  white-space: nowrap;
  padding: 1px 4px;
  max-width: 178px;
  text-align: center; 
  vertical-align: middle;
`

export const RowDiv = styled.div<CardProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content:${props => props.justifyContent ? props.justifyContent : 'center'};
  overflow: hidden;
`

export const PlayerImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 6px;
`

export const TextZone = styled.div<CardProps>`
  border-radius: 10px;
  padding: ${props => props.padding ? props.padding : '2px'};
  margin-left: ${props => props.marginLeft ? props.marginLeft : '0px'};
  color: white;
  font-weight: bold;
  display:flex;
  align-items: center;
  justify-content: center;
  height: 20 px;
  min-width: 16px;
  text-align: center;
  width:auto;
  ${props => {
    let color;
    let case1 = ['watch', 'zone 1', 'Sore'];
    let case2 = ['warning', 'zone 2'];
    let case3 = ['medical', 'zone 3'];
    let case4 = ['Pain'];
    if(case1.some(elem => elem === props.color)){
      color = 'rgba(255,191,86,1)';
    }
    else if(case2.some(elem => elem === props.color)){
      color = 'rgba(228,146,255,1)';
    }
    else if(case3.some(elem => elem === props.color)){
      color = 'rgba(0,155,158,1)';
    }
    else if(case4.some(elem => elem === props.color)){
      color = '#FF5E55';
    }
    else{
      color = '#F7F8FA';
    }
    const background = 'background-color:' + color + ';';
    return css`
         {
          ${background}
        }
      `;
  }};
`

export const ActionItemColumn = styled.div`
  width: 658px;
  max-width: 658px;
  min-width: 658px;
`


export const ActionItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 48px auto 0;
  max-width: 1330px;


  @media (max-width: 1330px) {
    justify-content:center;
  }
  @media (max-width: 690px) {
    justify-content:flex-start;
  }
`

export const TableDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 48px;
  color: #424854;
  font-size: 12px;
  border-top: 1px solid #F3F4F7;
`